





























































































































import { createComponent, ref, computed, reactive } from '@vue/composition-api';
import { signUpMutation } from '@/core/actions/login';
import { getCountries } from '@/core/actions/countries';
import { getRegions } from '@/core/actions/regions';
import UIInput from '@sbvr/lbe-ui/UIInput.vue';
import UIButton from '@sbvr/lbe-ui/UIButton.vue';
import UIAddressInputs from '@sbvr/lbe-ui/UIAddressInputs.vue';
import UICheckbox from '@sbvr/lbe-ui/UICheckbox.vue';
import UISelect from '@sbvr/lbe-ui/UISelect.vue';
import useFlashService from '@sbvr/lbe-web-panel/flash';
import BaseLayout from './layouts/BaseLayout.vue';
import { Country, Region } from '../../../../library/types';

export default createComponent({
  name: 'SignUpRoute',
  components: {
    UIInput,
    UIButton,
    UIAddressInputs,
    UICheckbox,
    UISelect,
    BaseLayout,
  },
  props: {
    isEntertainment: {
      type: Boolean,
      default: true,
    },
    isDeveloper: {
      type: Boolean,
    },
  },
  setup (props) {
    const hasSent = ref(false);
    const consent = ref(false);
    const hasSucceeded = ref(false);
    const { showFlash } = useFlashService();
    const defaultForm = {
      businessType: null,
      organizationName: '',
      organizationWebsite: '',
      organizationReferrer: '',
      organizationCountry: '',
      organizationState: '',
      organizationCity: '',
      organizationAddress: '',
      organizationAddress2: '',
      organizationPostalCode: '',
      organizationVatNumber: '',
      userFirstName: '',
      userLastName: '',
      userPosition: '',
      contactPhone: '',
      contactEmail: '',
      systemEmails: false,
    };
    const inEU = ref(false);
    const countryHasRegions = ref(false);
    const countries = ref<null | Country[]>(null);
    const regions = ref<null | Region[]>(null);
    const form = reactive({ ...defaultForm });
    function resetForm () {
      const defaultFormClone = { ...defaultForm };
      for (const k in form) {
        form[k] = defaultFormClone[k];
      }
      consent.value = false;
    }
    const fullAddress = computed(() => {
      const {
        organizationCountry: country,
        organizationState: state,
        organizationCity: city,
        organizationAddress: address,
        organizationAddress2: address2,
        organizationPostalCode: postalCode,
      } = defaultForm;
      return {
        country,
        state,
        city,
        address,
        address2,
        postalCode,
      };
    });
    const valid = computed(() => {
      const requiredFieldsForLBE = [
        'organizationName',
        'organizationCountry',
        'organizationState',
        'organizationCity',
        'organizationAddress',
        'organizationPostalCode',
        'userFirstName',
        'userLastName',
        'contactEmail',
      ];
      const requiredFieldsForDeveloper = [
        'businessType',
        'organizationName',
        'organizationCountry',
        'organizationState',
        'organizationCity',
        'organizationAddress',
        'organizationPostalCode',
        'userFirstName',
        'userLastName',
        'contactEmail',
        'contactPhone',
      ];
      let fieldsToValidate = props.isDeveloper ? requiredFieldsForDeveloper : requiredFieldsForLBE;
      if (inEU.value) {
        fieldsToValidate.push('organizationVatNumber');
      }
      if (!countryHasRegions.value) {
        fieldsToValidate = fieldsToValidate.filter(x => x !== 'organizationState');
      }
      return fieldsToValidate.every(v => Boolean(form[v])) && consent.value;
    });
    async function doSignUp () {
      hasSent.value = true;
      try {
        await signUpMutation({
          organizationType: props.isDeveloper ? 'developer' : 'entertainment',
          ...form,
        });
        resetForm();
        showFlash({
          type: 'success',
          message: 'Account successfully created.',
        });
        hasSucceeded.value = true;
      } catch (e) {
      } finally {
        hasSent.value = false;
      }
    }
    function onAddressChange ({ address, address2, city, state, postalCode, country }) {
      form.organizationAddress = address;
      form.organizationAddress2 = address2;
      form.organizationCity = city;
      form.organizationState = state;
      form.organizationPostalCode = postalCode;
      form.organizationCountry = country;

      const euCountries = ['BE', 'EL', 'GR', 'LT', 'PT', 'BG', 'ES', 'LU', 'RO', 'CZ', 'FR', 'HU', 'SI', 'DK', 'HR', 'MT', 'SK', 'DE', 'IT', 'NL', 'FI', 'EE', 'CY', 'AT', 'SE', 'IE', 'LV', 'PL'];
      inEU.value = euCountries.indexOf(country) !== -1;
      countryHasRegions.value = ['AU', 'CA', 'CN', 'IT', 'MX', 'MY', 'US'].indexOf(country) !== -1;
    }

    async function fetchCountries () {
      regions.value = await getRegions();
      countries.value = await getCountries();
    }
    fetchCountries();

    return {
      onAddressChange,
      doSignUp,
      form,
      hasSent,
      valid,
      consent,
      fullAddress,
      hasSucceeded,
      countries,
      regions,
      inEU,
    };
  },
});

